import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";
import React from "react";

interface ImageProps extends ComponentProps<"img"> {
  width?: number;
  height?: number;
  sizes?: string;
  srcset?: string;
  fetchpriority?: "high" | "low" | "auto";
}

export const Image = React.forwardRef<HTMLImageElement, ImageProps>(
  (
    {
      className,
      loading,
      decoding,
      alt,
      width,
      height,
      sizes,
      srcset,
      fetchpriority,
      ...props
    },
    ref,
  ) => {
    // In development, warn if alt text is not provided
    if (process.env.NODE_ENV === "development" && !alt) {
      console.warn(
        "Image component: alt text is required for accessibility. Please provide descriptive alt text or an empty string for decorative images.",
      );
    }

    return (
      <img
        ref={ref}
        className={cn("bg-neutral-100", className)}
        decoding={decoding || "async"}
        loading={loading || "lazy"}
        alt={alt ?? ""}
        width={width}
        height={height}
        sizes={sizes}
        srcSet={srcset}
        fetchPriority={fetchpriority}
        {...props}
      />
    );
  },
);

Image.displayName = "Image";
